import { useEffect, useState } from "react";
import type { LayoutField } from "@/components/features/matter/file-repo/signature-requests/SignatureRequestPdfLayoutEditor.constants";
import { SIGNER_FIELD_TEXT_BASELINE_OFFSET } from "@/components/features/matter/file-repo/signature-requests/SignatureRequestPdfLayoutEditor.constants";
import "./signerFieldTextStyle.css";

export const SIGNER_FONT_ASSETS = {
  "Times New Roman": "Tinos",
  Arial: "Arimo",
  "Courier New": "Cousine",
} as const;

export function SignerFieldText({
  field,
  value,
  scale,
  pageWidth,
}: {
  field: LayoutField;
  value: string;
  scale: number;
  pageWidth: number;
}) {
  const family = field.fontFamily ?? "Times New Roman";
  const [loadedFamily, setLoadedFamily] = useState<string>();
  useEffect(() => {
    let active = true;
    void document.fonts
      .load(`11px "Signer ${SIGNER_FONT_ASSETS[family]}"`)
      .then(() => {
        if (active) setLoadedFamily(family);
      })
      .catch(() => {
        if (active) setLoadedFamily(family);
      });
    return () => {
      active = false;
    };
  }, [family]);
  let size = (field.fontSize ?? 11) * scale;
  const context = document.createElement("canvas").getContext("2d");
  if (context && loadedFamily === family) {
    context.font = `${size}px "Signer ${SIGNER_FONT_ASSETS[family]}"`;
    const width = context.measureText(value).width;
    size *= Math.min(
      1,
      Math.max(field.width * pageWidth - 8 * scale, 1) / Math.max(width, 1),
    );
  }
  return (
    <span
      className="absolute block whitespace-pre text-black"
      style={{
        fontFamily: `"Signer ${SIGNER_FONT_ASSETS[family]}"`,
        fontSize: size,
        fontWeight: 400,
        lineHeight: 1,
        left: 4 * scale,
        bottom: Math.max(
          0,
          SIGNER_FIELD_TEXT_BASELINE_OFFSET * scale - size * 0.2,
        ),
      }}
    >
      {value}
    </span>
  );
}
